import { useState, useCallback } from "react";

/**
 * Hook to manage workspace modal dialog states and confirmations.
 */
export const useWorkspaceDialog = () => {
  const [dialogConfig, setDialogConfig] = useState({
    isOpen: false,
    type: null, // "RESTORE_DRAFT" | "NEW_PROJECT" | "SWITCH_LANGUAGE" | "LOAD_PROJECT" | "LOAD_LOCAL_PROJECT" | "RENAME"
    title: "",
    message: "",
    confirmText: "",
    confirmClass: "",
    cancelText: "",
    showInput: false,
    inputValue: "",
    payload: null,
  });

  const openDialog = useCallback((config) => {
    setDialogConfig({
      isOpen: true,
      type: config.type || null,
      title: config.title || "",
      message: config.message || "",
      confirmText: config.confirmText || "Confirm",
      confirmClass: config.confirmClass || "bg-purple-600 hover:bg-purple-500 text-white",
      cancelText: config.cancelText || "Cancel",
      showInput: !!config.showInput,
      inputValue: config.inputValue || "",
      payload: config.payload !== undefined ? config.payload : null,
    });
  }, []);

  const closeDialog = useCallback(() => {
    setDialogConfig((prev) => ({ ...prev, isOpen: false }));
  }, []);

  const setInputValue = useCallback((val) => {
    setDialogConfig((prev) => ({ ...prev, inputValue: val }));
  }, []);

  return {
    dialogConfig,
    setDialogConfig,
    openDialog,
    closeDialog,
    setInputValue,
  };
};

export default useWorkspaceDialog;
